import { handleToggleReceiveNoti, handleFcmPopupClosed, handlePermissionChange } from './handlers';

export default function initNotiSettings() {
	handleToggleReceiveNoti();
	handleFcmPopupClosed();
	handlePermissionChange();
}
